
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8YYHz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f2cdec493df54fb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $3f2cdec493df54fb$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Seite ohne Titel',
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Erstellen Sie eine neue Seite und f\xfcgen Sie sie als Link ein.",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence-Seite erstellen',
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "In Confluence \xf6ffnen",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Ihre Seite wurde erstellt',
    'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Seite erstellt',
    'editorExtensionLinkCreate.confluencePage.title': 'Neue Seite erstellen',
    'editorExtensionLinkCreate.genericError.description': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
    'editorExtensionLinkCreate.genericError.title': 'Etwas ist schiefgelaufen',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "Erstellen Sie einen Inline-Vorgang und f\xfcgen Sie den Vorgang als Link ein.",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira-Vorgang erstellen',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "In Jira \xf6ffnen",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Ihr Vorgang wurde erstellt',
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Vorgang erstellt',
    'editorExtensionLinkCreate.jiraIssue.title': 'Neuen Vorgang erstellen',
    'editorExtensionLinkCreate.keyword.create': 'erstellen',
    'editorExtensionLinkCreate.keyword.issue': 'Vorgang',
    'editorExtensionLinkCreate.keyword.new': 'neu',
    'editorExtensionLinkCreate.keyword.page': 'Seite',
    'editorExtensionLinkCreate.keyword.publish': "ver\xf6ffentlichen",
    'editorExtensionLinkCreate.keyword.raise': 'erstellen',
    'editorExtensionLinkCreate.keyword.space': 'Bereich',
    'editorExtensionLinkCreate.keyword.ticket': 'Ticket'
};

});


//# sourceMappingURL=de.cc9e5467.js.map
